import type { Ride } from '@trippath/shared';
import { useTranslation } from 'react-i18next';

import { minutesSaid } from '../../lib/clock';

/**
 * A ride's parts as the timetables have them: the walk to the stop, each line by its name and
 * colour from a stop to a stop and where it is headed, the walk from the last stop.
 */
export function RideLegs({ ride }: { ride: Ride }) {
  const { t } = useTranslation();
  return (
    <ol className="city-ride">
      {ride.legs.map((leg, index) => (
        <li key={`${String(index)} ${leg.from}`}>
          {leg.mode === 'walk' ? (
            <span className="quiet">
              {t('city.by.walk')} · {minutesSaid(leg.minutes)}
            </span>
          ) : (
            <>
              {leg.line !== null && (
                <strong
                  className="city-line"
                  style={leg.color === null ? undefined : { borderColor: `#${leg.color}` }}
                >
                  {leg.line}
                </strong>
              )}
              <span>
                {leg.from} → {leg.to}
              </span>
              <span className="quiet mono">{minutesSaid(leg.minutes)}</span>
              {leg.headsign !== null && (
                <small className="quiet city-towards">
                  {t('city.towards', { place: leg.headsign })}
                </small>
              )}
            </>
          )}
        </li>
      ))}
    </ol>
  );
}
